<template>
  <div>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="card card-wizard" id="wizardCard">
          <form-wizard ref="wizard"
                       @on-complete="wizardComplete"
                       @on-change="scrollToTop"
                       error-color="#31bebf"
                       title="Go COVID Clear Test Registration"
                       subtitle=""
                       color='#31bebf'>
  
            <tab-content :title="translatedFields['site']"
                         :before-change="validateFirstStep"
                         icon="ti-user">
              <first-step ref="firstStep"
                          v-on:jumpToTheNextPage="jumpToTheNextPage">
              </first-step>
            </tab-content>

            <tab-content :title="translatedFields['disclaimer']"
                         :before-change="validateSecondStep"
                         icon="ti-settings">
              <second-step ref="secondStep"
                           v-on:paymentSuccessful="paymentSuccessful"
                           v-on:nextTab="nextTab">
              </second-step>
            </tab-content>

            <button slot="prev" class="btn btn-default btn-fill btn-wd btn-back"><span>{{ translatedFields['back'] }} </span></button>
            <button slot="next" class="btn btn-fill btn-wd btn-next"><span> {{ translatedFields['next'] }}</span></button>
            <button slot="finish" :disabled="disabled" class="btn btn-info btn-fill btn-wd btn-submit"><span>  {{ submitButtonText }} </span></button>
          
          </form-wizard>

          <div class="row">
            <div class="col-md-12">
              <p v-if="allow_results" class="m-50">{{ translatedFields['check_your_results'] }}
                <router-link to="/patient/check-results" class="htrx-primary">{{ translatedFields['here'] }}</router-link>
              </p>
            </div>
          </div>
          <br><br>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import FirstStep from './Wizard/SiteSelectionStep.vue'
  import SecondStep from './Wizard/HomekitRegistration.vue'
  import swal from 'sweetalert2'
  import axios from 'axios'
  import { createToken } from 'vue-stripe-elements-plus'

  export default {
    data () {
      return {
        confirmationNumber: '',
        translatedFields: '',
        fields_en: {
          next: 'Next',
          back: 'Back',
          register: 'Register',
          patient_registration_form: 'Patient Registration Form',
          site: 'Site',
          medical_data: 'Medical Data',
          disclaimer: 'Disclaimer',
          insurance_information: 'Insurance Information',
          submission: 'Submission',
          check_your_results: 'Check your results',
          here: 'here'
        },
        allow_results: String(process.env.ALLOW_RESULTS) === 'true',
        allow_telehealth: String(process.env.ALLOW_TELEHEALTH) === 'true',
        allow_insurance: String(process.env.ALLOW_INSURANCE) === 'true',
        disabled: false,
        wizardModel: {}
      }
    },
    components: {
      FirstStep,
      SecondStep
    },
    mounted: function () {
      this.$sidebar.isMinimized = true
    },
    methods: {
      nextTab () {
        this.$refs.wizard.nextTab()
      },
      jumpToTheNextPage () {
        // this method will jump to the next page without any validation
        // do not use it
        this.$refs.wizard.changeTab(0, 1)
      },
      paymentSuccessful () {
        this.wizardComplete()
      },
      checkLanguage () {
        if (this.$store.state.lang.value === 'ES') {
          this.translatedFields = this.$store.state.translation_es
        } else {
          if (this.$store.state.lang.value === 'ZH') {
            this.translatedFields = this.$store.state.translation_zh
          } else {
            this.translatedFields = this.fields_en
          }
        }
      },
      async saveRegistration (data) {
        data.allow_payment = this.$store.state.cashPayment
        let result
        if (this.$store.state.cashPayment === 'true') {
          result = await createToken({name: this.$store.state.payment.cardHolderName, address_zip: this.$store.state.payment.cardZip})
          data.stripeToken = this.$store.state.stripeToken
        }
        this.translatedFields['register'] = 'Submitting.. Please wait'
        const self = this
        axios.post(process.env.SERVER_URI + '/register/' + this.$store.state.site.code, data)
        .then((response) => {
          let message = ''
          if (response.data === false) {
            if (this.$store.state.cashPayment === 'true') {
              message = 'There was an error submitting the data!<br> We did not proceed with the payment!'
            } else {
              message = 'There was an error submitting the data'
            }
            swal('Error!', message, 'error')
            self.redirect()
          } else {
            if (this.$store.state.cashPayment === 'true') {
              if (result.token) {
                axios.post(process.env.SERVER_URI + '/payment', { stripeToken: result.token.id, email: data.email, confirmation_number: response.data.confirmation_number })
          .then((paymentResponse) => {
            if (paymentResponse.data === 'true') {
              swal('Completed!', 'Your Registration Has Been Successfully Received.<br>Please check your email for confirmation!', 'success')
            } else {
              this.$store.state.paymentFailedMotive = paymentResponse.data
              this.$router.push({ name: 'PaymentWizard', params: {id: response.data.confirmation_number} })
            }
          }).catch(error => {
            if (error.paymentResponse.status === 403) {
              this.$router.push({ name: 'PaymentWizard', params: {id: response.data.confirmation_number} })
            } else {
              this.$router.push({ name: 'PaymentWizard', params: {id: response.data.confirmation_number} })
            }
          })
              }
            } else {
              swal('Completed!', 'Your registration has been received.<br>Please check your email for your confirmation number', 'success')
              .then(function (result) {
                window.location.reload()
              })
              .catch(swal.noop)
              self.redirect()
            }
            this.confirmationNumber = response.data[0].confirmation_number
            self.redirectHome()
          }
        }).catch(error => {
          if (error.response.status === 429) {
            let message = ''
            if (this.$store.state.cashPayment) {
              message = 'It looks like you already registered! Please check your email for the confirmation number or try again later.<br> We did not proceed with the payment!'
            } else {
              message = 'It looks like you already registered! Please check your email for the confirmation number or try again later'
            }
            swal('Error!', message, 'error')
            .then(function (result) {
              window.location.reload()
            })
            .catch(swal.noop)
            self.redirect()
          } else {
            swal('Error!', 'There was an error submitting the data', 'error')
            .then(function (result) {
              window.location.reload()
            })
            self.redirect()
          }
        })
      },
      redirect () {
        const body = document.querySelector('body')
        body.onclick = function () {
          window.location.reload()
        }
      },
      redirectHome () {
        const body = document.querySelector('body')
        const self = this
        body.onclick = function () {
          self.$router.push({ path: '/patient/home/' + self.confirmationNumber })
        }
      },
      validateFirstStep () {
        return this.$refs.firstStep.validate()
      },
      validateSecondStep () {
        return this.$refs.secondStep.validate()
      },
      wizardComplete: function () {
        this.disabled = true
        this.wizardModel = {
          ...this.$refs.firstStep.model,
          ...this.$refs.secondStep.model
        }
        this.saveRegistration(this.wizardModel)
      },
      scrollToTop () {
        let elmnt = document.getElementsByClassName('main-panel')[0]
        elmnt.scrollTo(0, 0)
      }
    },
    computed: {
      ...mapFields(['callingSchedule']),
      language () {
        this.checkLanguage()
        return this.$store.state.lang.value
      },
      spanishFields () {
        return this.$store.state.translation_es
      },
      chineseFields () {
        return this.$store.state.translation_zh
      },
      submitButtonText () {
        return 'Submit'
      }
    },
    watch: {
      language () {
        this.checkLanguage()
      }
    }
  }
</script>
<style scoped>
  >>> .vue-form-wizard .wizard-icon-circle {
    background-color: white;
    color: #000000;
    border: 3px solid #323737;
  }

  >>> .vue-form-wizard .wizard-nav-pills>li>a {
    color: #323737;
  }

  >>> div[aria-selected="true"]{
    background-color: #31bebf !important;
  }

  span button {
    transition: 0.5s;
  }

  .btn-next {
    background-color: white !important;
    color: #323737 !important;
    min-height: 40px;
    border: 2px solid #31bebf !important;
    border-radius: 20px;
  }

  .btn-next:hover{
    border: none;
    background-color: #31bebf !important;
    color: white !important;
    padding-right: 25px;
  }

  .btn-next:focus{
    border: none !important;
    background-color: #31bebf !important;
    color: white !important;
    padding-right: 25px;
  }

  .btn-next span:after {
    content: '\00bb';
    opacity: 1;
    font-size: 17px;
    margin-left: 5px;
  }

  .btn-back{
    background-color: transparent !important;
    color: #f4c617 !important;
    min-height: 40px;
    border: none;
    border-radius: 20px;
  }

  .btn-back span:before {
    content: '\00AB';
    opacity: 1;
    font-size: 17px;
    margin-right: 5px;
  }

  .btn-back:hover{
    border: none !important;
    background-color: #f4c617 !important;
    color: white !important;
    padding-right: 25px;
  }

  .btn-back:focus{
    border: none !important;
    background-color: #f4c617 !important;
    color: white !important;
    padding-right: 25px;
  }

  .btn-submit{
    background-color: white !important;
    color:  #323737 !important;
    min-height: 40px;
    border: 2px solid #31bebf !important;
    border-radius: 20px;
  }

  .btn-submit:hover{
    border: none;
    background-color: #31bebf !important;
    color: white !important;
    padding-right: 25px;
  }

  .btn-submit:focus{
    border: none;
    background-color: #31bebf !important;
    color: white !important;
    padding-right: 25px;
  }

  .btn-submit span:after {
    content: '\2713';
    opacity: 1;
    font-size: 17px;
    margin-left: 5px;
  }

  .m-50{
    margin-top: 20px;
    padding-bottom: 20px;
    margin-left: 20px;
  }

  .htrx-primary{
    color: #31bebf;
  }

  @media (max-width: 400px) {
    >>> .vue-form-wizard .wizard-card-footer {
      display: -webkit-box;
      display: -moz-box;
      display: box;

      -webkit-box-orient: vertical;
      -moz-box-orient: vertical;
      box-orient: vertical;
    }

    >>> .vue-form-wizard .wizard-card-footer .wizard-footer-right {
      position: relative;
      min-height: 1px;
      width: 100%;
      margin-top: 10px;

      -webkit-box-ordinal-group: 1;
      -moz-box-ordinal-group: 1;
      box-ordinal-group: 1;
    }

    >>> .vue-form-wizard .wizard-card-footer .wizard-footer-left {
      position: relative;
      min-height: 1px;
      width: 100%;

      -webkit-box-ordinal-group: 2;
      -moz-box-ordinal-group: 2;
      box-ordinal-group: 2;
    }

    .btn-back{
      width: 100%;
    }

    .btn-next{
      width: 100%;
    }

    .btn-submit{
      width: 100%;
    }

    >>> span[role=button] {
      width: 100% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Homekit/HomekitWizard.vue